import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const RIDER_SEARCH_RADAR_KEY = 'rider.searchRadar';
export const RIDER_SEARCH_RADAR_BOUNDS = {
    maxVehicles: { min: 0, max: 20 },
};
export const DEFAULT_RIDER_SEARCH_RADAR = { maxVehicles: 12 };
/** An unreadable version: the radar draws no vehicle, and the words still say the count. */
export const STRICT_RIDER_SEARCH_RADAR = { maxVehicles: RIDER_SEARCH_RADAR_BOUNDS.maxVehicles.min };
export const RIDER_SEARCH_RADAR_POLICY_REASON_CODES = ['RIDER_SEARCH_RADAR_POLICY_GOVERNED', 'RIDER_SEARCH_RADAR_POLICY_DEFAULT', 'RIDER_SEARCH_RADAR_POLICY_INVALID'];
/** The stable issue of a value that is not a `rider.searchRadar` value, or undefined when it is one. */
export function riderSearchRadarIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['maxVehicles']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = RIDER_SEARCH_RADAR_BOUNDS.maxVehicles;
    if (!intWithin(v.maxVehicles, b.min, b.max))
        return 'INVALID_MAX_VEHICLES';
    return undefined;
}
export const RIDER_SEARCH_RADAR_SPEC = {
    key: RIDER_SEARCH_RADAR_KEY,
    issue: riderSearchRadarIssue,
    copy: (v) => ({ maxVehicles: v.maxVehicles }),
    defaultValue: DEFAULT_RIDER_SEARCH_RADAR,
    strictValue: STRICT_RIDER_SEARCH_RADAR,
    reasonPrefix: 'RIDER_SEARCH_RADAR_POLICY',
};
export function riderSearchRadarSetting(input) {
    return marketRuleSetting(RIDER_SEARCH_RADAR_SPEC, input);
}
export function resolveRiderSearchRadar(versions, marketId, at, regionCode) {
    return resolveMarketRule(RIDER_SEARCH_RADAR_SPEC, versions, marketId, at, regionCode);
}
//# sourceMappingURL=rider-search-radar-policy.js.map